<template>
  <v-snackbar v-model="show" :color="color" :timeout="timeout" top>
    {{ message }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="hide">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "GlobalSnackbar",
  computed: {
    message() {
      return this.$store.state.snackbar.message;
    },
    color() {
      return this.$store.state.snackbar.color;
    },
    timeout() {
      return this.$store.state.snackbar.timeout;
    },
    show: {
      get() {
        return this.$store.state.snackbar.visible;
      },
      set(value) {
        if (!value) {
          this.$store.dispatch("snackbar/hideSnackbar");
        }
      },
    },
  },
  methods: {
    hide() {
      this.$store.dispatch("snackbar/hideSnackbar");
    },
  },
};
</script>

<style scoped>
/* Add any specific styles for your snackbar here if needed */
</style>
